
const onDemand = [
  {
    productId: 245000673560170,
    productRef: 256345160170,
    title: "Slush Comfy Set",
    productName: 'SLUSH COMFY SET',
    shortDescription: "100% durable furniture. Choose wide range inches for desired area.",
    imageURL: `https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538817/shop/adverts/furniture_-_Copy_lfpacq.jpg`,
    imgUrl1: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538817/shop/adverts/furniture_-_Copy_lfpacq.jpg',
    imgUrl2: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538817/shop/adverts/furniture_-_Copy_lfpacq.jpg',
    imgUrl3: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538817/shop/adverts/furniture_-_Copy_lfpacq.jpg',
    imgUrl4:  'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538817/shop/adverts/furniture_-_Copy_lfpacq.jpg',
    imgUrl5: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538817/shop/adverts/furniture_-_Copy_lfpacq.jpg',
    imgUrl6: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538817/shop/adverts/furniture_-_Copy_lfpacq.jpg',
    imgUrl7: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538817/shop/adverts/furniture_-_Copy_lfpacq.jpg',
    imgUrl8: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538817/shop/adverts/furniture_-_Copy_lfpacq.jpg',
    imgUrl9: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538817/shop/adverts/furniture_-_Copy_lfpacq.jpg',
    imgUrl10: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538817/shop/adverts/furniture_-_Copy_lfpacq.jpg',
    videourl: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/Luxury3BedroomApartmentShelteAfriqueExt.mp4',
    dummyUrl: '../../images/product1/emeraldStone.jpg',
    displayPrice: "2500 per month",
    price: 1500,
    currency: '₦',
    availableUnits: 1,
    negotiable: false,
    contactNo: '08036096802',
    date_posted: '03-09-2025',
    city: 'Uyo',
    state: 'Akwa-Ibom',
    areaName: 'Shelter Afrique',
    category: 'House-Holds',
    group: 'Comfortable-Chairs',
    availability: true,
    locationImg: `${`📍`}`,
    priceImg: `${`💵`}`,
    description: `
    Features:\n
   
    --- 
    ✨ Key Features  
    - 120' Inches wide 4 seater
    - Complete set of two pairs of 2 seater and 1 seater each 
    To the touch, the sofa is richly tactile. The areas of full color are smooth and cool, more
    supple, elegant and have a gentle, inviting grain. It feels inherently lived-in and storied. 
    `,
  },
  {
    productId: 245000673560171,
    productRef: 256345160171,
    title: "Dining Set",
    productName: 'Dining Set',
    shortDescription: "Available in desired look and feel. High in quality and made to specification.",
    imageURL: `https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png`,
    imgUrl1: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
    imgUrl2: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
    imgUrl3: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
    imgUrl4:  'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
    imgUrl5: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
    imgUrl6: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
    imgUrl7: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
    imgUrl8: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
    imgUrl9: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
    imgUrl10: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
    videourl: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539328/shop/adverts/brown-wooden-table-with-chairs-3773579_zbtvwt.png',
    dummyUrl: '../../images/product1/emeraldStone.jpg',
    displayPrice: "2500 per month",
    price: 850,
    currency: '₦',
    availableUnits: 1,
    negotiable: false,
    contactNo: '08036096802',
    date_posted: '03-09-2025',
    city: 'Uyo',
    state: 'Akwa-Ibom',
    areaName: 'Shelter Afrique',
    category: 'House-Holds',
    group: 'Dinning-Set',
    availability: true,
    locationImg: `${`📍`}`,
    priceImg: `${`💵`}`,
    description: `
    Features:\n
       
    ---
    
    ✨ Key Features  
    - Alluring look + glossy touch and feel  
    - Treated against Insects and pests.  
    - Durable + Hard Solid wooding and framework 
    - Impenetrable by liquid substances  
    - Non-combustible and environmental friendly  
    `,
  },
  {
    productId: 245000673560172,
    productRef: 256345160172,
    title: "Dumbell",
    productName: "Dumbell",
    shortDescription: "100% made to keep fit.Choose from a variety for healthier living.",
    imageURL: `https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539890/shop/adverts/dumbell_a60fkm.jpg`,
    imgUrl1: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539890/shop/adverts/dumbell_a60fkm.jpg',
    imgUrl2: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539890/shop/adverts/dumbell_a60fkm.jpg',
    imgUrl3: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539890/shop/adverts/dumbell_a60fkm.jpg',
    imgUrl4:  'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539890/shop/adverts/dumbell_a60fkm.jpg',
    imgUrl5: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539890/shop/adverts/dumbell_a60fkm.jpg',
    imgUrl6: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539890/shop/adverts/dumbell_a60fkm.jpg',
    imgUrl7: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539890/shop/adverts/dumbell_a60fkm.jpg',
    imgUrl8: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539890/shop/adverts/dumbell_a60fkm.jpg',
    imgUrl9: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539890/shop/adverts/dumbell_a60fkm.jpg',
    imgUrl10: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539890/shop/adverts/dumbell_a60fkm.jpg',
    videourl: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595539890/shop/adverts/dumbell_a60fkm.jpg',
    dummyUrl: '../../images/product1/emeraldStone.jpg',
    availability: true,
    locationImg: `${`📍`}`,
    priceImg: `${`💵`}`,
    description: `
    Features:\n
    

    ---  
    ✨ Key Features  
    - Built to last  
    - Perfected for good grip 
    `,
    displayPrice: "2500 per month",
    price: 1500,
    currency: ' ₦',
    availableUnits: 1,
    negotiable: false,
    contactNo: '08036096802',
    date_posted: '03-09-2025',
    city: 'Port Harcourt',
    state: 'Rivers',
    areaName: 'Eliozu',
    category: 'House-Holds',
    group: 'Gym-Equipment',
  },
  {
    productId: 245000673560173,
    productRef: 256345160173,
    title: "Window Blind",
    productName: "Window Blind",
    shortDescription: "Zero shedding, non brittle, non combustible, suitable for home & office.",
    imageURL: `https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538653/shop/adverts/steve-johnson-3fjO_A5tmHE-unsplash_sttckp.jpg`,
    imgUrl1: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538653/shop/adverts/steve-johnson-3fjO_A5tmHE-unsplash_sttckp.jpg',
    imgUrl2: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538653/shop/adverts/steve-johnson-3fjO_A5tmHE-unsplash_sttckp.jpg',
    imgUrl3: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538653/shop/adverts/steve-johnson-3fjO_A5tmHE-unsplash_sttckp.jpg',
    imgUrl4:  'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538653/shop/adverts/steve-johnson-3fjO_A5tmHE-unsplash_sttckp.jpg',
    imgUrl5: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538653/shop/adverts/steve-johnson-3fjO_A5tmHE-unsplash_sttckp.jpg',
    imgUrl6: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538653/shop/adverts/steve-johnson-3fjO_A5tmHE-unsplash_sttckp.jpg',
    imgUrl7: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538653/shop/adverts/steve-johnson-3fjO_A5tmHE-unsplash_sttckp.jpg',
    imgUrl8: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538653/shop/adverts/steve-johnson-3fjO_A5tmHE-unsplash_sttckp.jpg',
    imgUrl9: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538653/shop/adverts/steve-johnson-3fjO_A5tmHE-unsplash_sttckp.jpg',
    imgUrl10: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595538653/shop/adverts/steve-johnson-3fjO_A5tmHE-unsplash_sttckp.jpg',
    videourl: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/Luxury3BedroomApartmentShelteAfriqueExt.mp4',
    dummyUrl: '../../images/product1/emeraldStone.jpg',
    availability: true,
    locationImg: `${`📍`}`,
    priceImg: `${`💵`}`,
    description: `
    Features:\n
    

    ---
    
    ✨ Key Features  
    - Durable  
    - Aesthetically pleasing  
    - Made with finest quality  
    - Available in multi-colors  
    `,
    displayPrice: "2500 per month",
    price: 1500,
    currency: ' ₦',
    availableUnits: 1,
    negotiable: false,
    contactNo: '08036096802',
    date_posted: '03-09-2025',
    city: 'Port Harcourt',
    state: 'Rivers',
    areaName: 'Eliozu',
    category: 'House-Holds',
    group: 'Window-Blinds',
  },
  {
    productId: 245000673560174,
    productRef: 256345160174,
    title: "Wall Frames",
    productName: "Wall Frames",
    shortDescription: "Mimicks your imagination, providing a flawless see through.",
    imageURL: `https://res.cloudinary.com/daw8l0o1v/image/upload/v1595540132/shop/adverts/wallframe_fmzfuf.jpg`,
    imgUrl1: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595540132/shop/adverts/wallframe_fmzfuf.jpg',
    imgUrl2: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595540132/shop/adverts/wallframe_fmzfuf.jpg',
    imgUrl3: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595540132/shop/adverts/wallframe_fmzfuf.jpg',
    imgUrl4:  'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595540132/shop/adverts/wallframe_fmzfuf.jpg',
    imgUrl5: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595540132/shop/adverts/wallframe_fmzfuf.jpg',
    imgUrl6: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595540132/shop/adverts/wallframe_fmzfuf.jpg',
    imgUrl7: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595540132/shop/adverts/wallframe_fmzfuf.jpg',
    imgUrl8: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595540132/shop/adverts/wallframe_fmzfuf.jpg',
    imgUrl9: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595540132/shop/adverts/wallframe_fmzfuf.jpg',
    imgUrl10: 'https://res.cloudinary.com/daw8l0o1v/image/upload/v1595540132/shop/adverts/wallframe_fmzfuf.jpg',
    videourl: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/Luxury3BedroomApartmentShelteAfriqueExt.mp4',
    dummyUrl: '../../images/product1/emeraldStone.jpg',
    availability: true,
    locationImg: `${`📍`}`,
    priceImg: `${`💵`}`,
    description: `
    Features:\n
      
    ---
    
    ✨ Key Features  
    - Durable  
    - Aesthetically pleasing  
    - Made with finest quality  
    - Available in multi-colors  
    `,
    displayPrice: "2500 per month",
    price: 1500,
    currency: ' ₦',
    availableUnits: 1,
    negotiable: false,
    contactNo: '08036096802',
    date_posted: '03-09-2025',
    city: 'Port Harcourt',
    state: 'Rivers',
    areaName: 'GRA',
    category: 'House-Holds',
    group: 'Wall-Frames',
  },
];

export default onDemand;


//   📍 Shelter Afrique Estate Extension.  
//    💵₦250K